export default "__VITE_ASSET__BGQ8MSWc__"